import * as React from 'react';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
import { scrollToTop } from '../core/index';
export interface PageMasterProps extends BaseComponentProps { lang: string; content: string  | undefined; }
export interface PageMasterState extends BaseComponentState { }
export class PageMaster extends BaseComponent<PageMasterProps, PageMasterState> {
    constructor(props: PageMasterProps) {
        super(props);
    }

    componentDidUpdate() {
        scrollToTop();
    }

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let renderDesctiption = (x: any) => {
            return { __html: x };
        };
        return (
            <div dangerouslySetInnerHTML={renderDesctiption(this.props.content)} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/static-content/PageMaster.tsx